import Model from './BaseModel';

export default class BetType extends Model {
	resourceName() {
		return 'bet_types';
	}

	fields() {
		return ['is_exotic', 'name'];
	}

	resourceUrl() {
		return 'bet_types/racings/';
	}
}
